import * as React from "react";
import {database, globalSettings} from "./config";
import {getMaterialsMap, getRecipesAsList, STATUS_BUILT, STATUS_CLAIMED, STATUS_DELIVERING, STATUS_QUEUED} from "./model/data";
import {forceDiscordAuth} from "./discord";


export const UserInfo = React.createContext(null);
export const GlobalInfo = React.createContext(null);

let numReads = 0;

function logRead(n) {
  numReads += n;
  //console.log(numReads)
}

export class GlobalContextProvider extends React.Component {
  componentDidMount() {
    console.log("Loading data...");
    database.collection("users").doc(this.context.id).onSnapshot((doc) => {
      // console.log(doc.metadata);
      // if (doc.metadata.hasPendingWrites) {
      //   return
      // }
      logRead(1);
      let userData = doc.data();

      if (localStorage.getItem("noAdmin")) {
        userData.roles = {member: true};
      }

      this.setState({
        userData: userData,
        userInfo: {
          name: userData.name,
          id: userData.id,
          roles: userData.roles,
        },
        roles: userData.roles,
      });
      console.log("Loaded user data");

    });
    getMaterialsMap(newMaterialsMap => {
      let materials = Object.values(newMaterialsMap);
      materials.sort((a, b) => (a.order || 99) - (b.order || 99));
      logRead(materials.length);
      this.setState({
        materialsMap: newMaterialsMap,
        materials: materials,
      })
      console.log("Loaded materials");

    });
    getRecipesAsList((newRecipes) => {
      logRead(newRecipes.length);
      let recipeMap = {};
      newRecipes.forEach((recipe) => {
        recipeMap[recipe.name] = recipe;
      });
      this.setState({
        recipes: newRecipes,
        recipeMap: recipeMap,
      })
      console.log("Loaded recipes");

    });
    database.collection("queue").where("status", "in", [
      STATUS_QUEUED, STATUS_CLAIMED, STATUS_BUILT, 1, STATUS_DELIVERING
    ]).onSnapshot((querySnapshot) => {
      let newQueue = [];
      querySnapshot.forEach(function (doc) {
        let data = doc.data();
        data.id = doc.id;
        newQueue.push(data);
      });
      newQueue.sort((a, b) => a.timestamp - b.timestamp);
      logRead(newQueue.length);
      this.setState({queue: newQueue});
      console.log("Loaded queue");

    });
    database.collection("users").onSnapshot((querySnapshot) => {
      let users = [];
      let usersMap = {};
      querySnapshot.forEach(function (doc) {
        let data = doc.data();
        users.push(data);
        usersMap[data.id] = data;
      });
      logRead(users.length);
      this.setState({
        users: users,
        userMap: usersMap,
      });
      console.log("Loaded user list");
    });
    database.collection("requests").onSnapshot((querySnapshot) => {
      let requests = [];
      querySnapshot.forEach(function (doc) {
        let data = doc.data();
        data.id = doc.id;
        requests.push(data);
      });
      this.setState({
        requests: requests,
      })
      console.log("Loaded requests");
    });
  }

  render() {
    let value = Object.assign({}, this.state);
    value.userInfo = this.context;
    value.globalSettings = globalSettings;  // Include globalSettings from config.js

    let isLoaded = this.state &&
        !!(this.state.userData) &&
        !!(this.state.materialsMap) &&
        !!(this.state.recipes) &&
        !!(this.state.queue) &&
        !!(this.state.users) &&
        !!(this.state.requests);

    if(isLoaded) {
      console.log("Loading complete!")
    }

    return <GlobalInfo.Provider value={value}>
      {isLoaded ? this.props.children : <div className={"container-fluid text-center"}>
        <div className={"loader mb-2"} />
        <div className={"mb-2"}>Loading...</div>
        <p className={"text-muted text-left"}>
          If loading gets stuck, try:
          <ol>
            <li>Disable your ad or tracking blocker on this site</li>
            <li><a href={"https://balsamiq.com/support/faqs/browserconsole/"} target={"_blank"} rel={"noopener noreferrer"}>Open your browser console</a>, take a screenshot, and post it to #app-questions-feedback on Discord</li>
          </ol>
        </p>
      </div>}
    </GlobalInfo.Provider>
  }
}

GlobalContextProvider.contextType = UserInfo;